import React, { useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, InputAdornment } from '@mui/material';

import * as ST from './styles';

const ChatField = ({
  isLoading,
  selectedMode,
  currentUserMessage,
  setCurrentUserMessage,
  handleSendRequest,
  setIsDraggerDisabled,
  isDeepResearch,
  setIsDeepResearch,
  saveAsCollection,
  setSaveAsCollection,
  showDeepResearch,
  showSaveAsCollection,
}) => {
  useEffect(() => {
    if (!showDeepResearch && isDeepResearch) {
      setIsDeepResearch(false);
    }
  }, [showDeepResearch, isDeepResearch, setIsDeepResearch]);
  const handleSubmit = (event) => {
    event.preventDefault();
    handleSendRequest(currentUserMessage, isDeepResearch, saveAsCollection);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ pt: 0, pr: '9px', pb: '9px', pl: '9px' }}>
        {showDeepResearch && (
          <FormControlLabel
            control={
              <Checkbox
                checked={isDeepResearch}
                onChange={(e) => setIsDeepResearch(e.target.checked)}
                disabled={isLoading}
              />
            }
            label="Activate Deep Research"
            sx={{
              mt: 0.25,
              display: 'flex',
              justifyContent: 'flex-start',
              color: 'text.secondary',
              padding: 0,
              '& .MuiButtonBase-root': {
                paddingTop: 0,
                paddingBottom: 0,
                margin: 0,
              },
              '& .MuiFormControlLabel-label': {
                fontSize: '14px',
              },
            }}
          />
        )}
        {showDeepResearch &&
          showSaveAsCollection &&
          isDeepResearch &&
          selectedMode !== 'Private AI' && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={saveAsCollection}
                  onChange={(e) => setSaveAsCollection(e.target.checked)}
                  disabled={isLoading}
                />
              }
              label="Save as Collection"
              sx={{
                mt: 0.25,
                display: 'flex',
                justifyContent: 'flex-start',
                color: 'text.secondary',
                padding: 0,
                '& .MuiButtonBase-root': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  margin: 0,
                },
                '& .MuiFormControlLabel-label': {
                  fontSize: '14px',
                },
              }}
            />
          )}
      </Box>
      <ST.StyledQuestionField
        disabled={isLoading}
        placeholder={
          isDeepResearch
            ? 'Write your research prompt'
            : selectedMode === 'AI chat'
            ? 'Type your question...'
            : 'Write your prompt...'
        }
        value={currentUserMessage}
        onChange={(e) => {
          setCurrentUserMessage(e.target.value);
        }}
        onDoubleClick={(e) => e.stopPropagation()}
        onMouseEnter={() => setIsDraggerDisabled(true)}
        onMouseLeave={() => setIsDraggerDisabled(false)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <ST.StyledButton
                type="submit"
                startIcon={<ST.StyledSendIcon />}
              />
            </InputAdornment>
          ),
        }}
      />
    </form>
  );
};

export default ChatField;
